// Shared by the video, overlay and audio track components
export default {
	props: {
		// Row of build_track_rows: {id, kind, name, hidden, muted, items, lanes}
		track: Object,
		// Pixels per second
		zoom: Number,
		lane_height: Number,
		// Item that follows the pointer while moved: {kind, id, grab_y, y}
		follow: Object
	},
	computed: {
		track_style () {
			return {height: this.track.lanes * this.lane_height + "px"};
		}
	},
	methods: {
		block_style (start, len, lane, kind, id) {
			return Object.assign({
				left: start * this.zoom + "px",
				width: Math.max(len * this.zoom, 6) + "px",
				top: lane * this.lane_height + "px",
				height: this.lane_height - 4 + "px"
			}, this.follow_style(kind, id, lane));
		},
		// While an item is moved it follows the pointer vertically, even though it belongs to a snapped track
		follow_style (kind, id, lane) {
			const f = this.follow;
			if (!f || f.kind != kind || f.id != id || !this.$el || !this.$el.getBoundingClientRect) return {};
			const box = this.$el.getBoundingClientRect();
			const lifted = {zIndex: 5, boxShadow: "0 6px 16px rgba(0, 0, 0, 0.5)", cursor: "grabbing"};
			// The item stays on its track while the pointer is inside it and only comes loose once the pointer leaves the track
			if (f.y >= box.top && f.y <= box.bottom) return lifted;
			const rest = box.top + lane * this.lane_height;
			return Object.assign(lifted, {transform: "translateY(" + (f.y - f.grab_y - rest) + "px)"});
		}
	}
}
